import type { SVGProps } from 'react'
const SvgSyViewHide = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<g fillRule="evenodd" clipRule="evenodd">
			<path d="M15.92 12.799Q16 12.41 16 12a4 4 0 0 0-4.799-3.92zM8.667 9.788a4 4 0 0 0 5.545 5.545z" />
			<path
				fillOpacity={0.24}
				d="m15.787 16.909-8.929-8.93c-1.314.986-2.373 2.138-3.046 2.955-.388.472-.582.707-.582 1.066s.194.594.582 1.066C5.232 14.79 8.364 18 12 18c1.353 0 2.636-.444 3.787-1.091M9.577 6.456A7 7 0 0 1 12 6c3.636 0 6.768 3.21 8.188 4.934.388.472.582.707.582 1.066s-.194.594-.582 1.066a19.5 19.5 0 0 1-1.95 2.05z"
			/>
			<path d="M15.92 12.799Q16 12.41 16 12a4 4 0 0 0-4.799-3.92zM8.667 9.788a4 4 0 0 0 5.545 5.545z" />
		</g>
		<path d="m8.424 4.576-.848.848 12 12 .848-.848z" />
	</svg>
)
export default SvgSyViewHide
